import { CircularProgress } from "@mui/material";
import { BIBlue } from "../assets/helpers";
import { useSelector } from "react-redux";

function Loader({ fullScreen = false }) {
  const { selectedClientData } = useSelector((state) => state?.main);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: fullScreen ? "100vh" : "100%",
        width: "100%"
      }}>
      <CircularProgress
        sx={{
          color:
            selectedClientData?.AccentColor !== undefined && selectedClientData?.AccentColor
              ? selectedClientData?.AccentColor
              : BIBlue
        }}
        style={{ " & span": { width: "200px" } }}
      />
    </div>
  );
}

export default Loader;
